import { setWorkerUrl } from 'maplibre-gl'
import workerUrl from 'maplibre-gl/dist/maplibre-gl-worker.mjs?worker&url'

// MapLibre 6 ships a separate worker. Vite must bundle that worker and its
// shared imports; resolving it relative to the vendor chunk returns SPA HTML.
setWorkerUrl(workerUrl)
